module.exports = __webpack_public_path__ + "img/dex.23231a39.svg";